// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'column-no-left';

export const Component = () => (
  <path d='M5.89 24.521V0h.958v24.521h-.957Zm8.813 0V0h1.006v24.521h-1.006Zm4.502 0H.479v-.958h18.726c1.197 0 2.203-.335 3.065-1.054.861-.67 1.293-1.484 1.293-2.394V4.406c0-.91-.432-1.724-1.293-2.442-.862-.67-1.868-1.005-3.065-1.005H.479V0h18.726c1.484 0 2.73.431 3.783 1.293 1.006.861 1.533 1.915 1.533 3.113v15.709c0 1.197-.526 2.25-1.533 3.113-1.054.862-2.299 1.293-3.783 1.293ZM0 .958V0h2.155v.958H0ZM0 24.52v-.958h2.155v.958H0Z' />
);

export const viewBox = '0 0 25 25';
